import { render, staticRenderFns } from "./SWOPreviewModal.vue?vue&type=template&id=856b2f12&scoped=true&"
import script from "./SWOPreviewModal.vue?vue&type=script&lang=js&"
export * from "./SWOPreviewModal.vue?vue&type=script&lang=js&"
import style0 from "./SWOPreviewModal.vue?vue&type=style&index=0&id=856b2f12&prod&scoped=true&lang=css&"
import style1 from "./SWOPreviewModal.vue?vue&type=style&index=1&id=856b2f12&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856b2f12",
  null
  
)

export default component.exports